export default "__VITE_ASSET__d10890c7__"